import { useDialog } from '@dni-hooks/useDialog'
import { useApiPaymentTransaction } from '@hooks-api/eCommerceV2/useApiPaymentTransaction'
import { Box } from '@pets-ui/Box/Box'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { ResponsiveDialog } from '@pets-ui/ResponsiveDialog/ResponsiveDialog'
import { useParams } from 'react-router-dom-v5'
import { useCheckout } from '../../../../fp-b2b-shared/hooks/use-checkout'
import { PaymentDetailsUI } from '../PaymentDetailsUI'

export const RETRY_PAYMENT_DIALOG_KEY = 'DialogRetryPaymentDetail'

export function DialogRetryPaymentDetail() {
  const { open, closeDialog } = useDialog(RETRY_PAYMENT_DIALOG_KEY)
  const { countryCode } = useCheckout()
  const { transactionId } = useParams<{ transactionId?: string }>()
  const { destructuredData: transaction } = useApiPaymentTransaction(countryCode
    ? {
      country_code: countryCode,
      payment_transaction_id: transactionId ?? '',
    }
    : undefined)
  return (
    <ResponsiveDialog open={open} onClose={closeDialog} fullWidth>
      <DialogHeader title="付款明細" onClose={closeDialog} />
      <Box padding={4}>
        <PaymentDetailsUI
          currency={transaction?.currency || '(幣別未知)'}
          discountItems={transaction?.discount_items || []}
          shippingTotal={transaction?.shipping_total ?? 0}
          total={transaction?.total ?? 0}
          subtotal={transaction?.subtotal ?? 0}
          tax={transaction?.tax ?? 0}
          countryCode={countryCode}
          addonV2Total={transaction?.addon_v2_total ?? 0}
          addonV2TotalBeforeDiscount={transaction?.addon_v2_total_before_discount ?? 0}
        />
      </Box>
    </ResponsiveDialog>
  )
}
